import * as utils from '../../utils/utils';

export default function useFilters(filters, baseURL) {
    let searchParams = null;

    function parseFiltersFromURLParams() {
        searchParams = new URLSearchParams(window.location.search);
        for (const [name, value] of searchParams.entries()) {
            parseParam(name, value);
        }
    }

    function parseParam(name, value) {
        if (filterIsAccessibleBy(name)) {
            // if the filter is an array split values by commas, otherwise cast it to a number if possible
            if (Array.isArray(filters[name])) {
                filters[name] = utils.splitCommaSeparatedStringToArrayOfNums(value);
            } else {
                filters[name] = utils.stringIsInt(value) ? +value : value;
            }
        }
    }

    function buildURLSearchParams(page = 1) {
        let filtersToUse = { ...filters };
        filtersToUse.page = page;

        const params = new URLSearchParams();

        Object.keys(filtersToUse).forEach((name) => {
            if (!utils.isEmpty(filtersToUse[name])) {
                let value = filtersToUse[name];
                value = Array.isArray(value) ? value.join() : value.toString();
                params.append(name, value);
            }
        });

        return (searchParams = params);
    }

    function buildURL(page = 1) {
        const params = buildURLSearchParams(page);
        return baseURL + '?' + params.toString();
    }

    /*
     | ----------
     | Helpers
     | ----------
     */

    const setFilterValue = (filterName, value) => {
        if (!filterIsAccessibleBy(filterName)) {
            throw new Error(`The filter does not have the "${filterName}" property.`);
        }
        filters[filterName] = value;
    };

    // const filterHasValue = (filterName) => filterIsAccessibleBy(filterName) && !utils.isEmpty(filters[filterName]);

    const filterIsAccessibleBy = (filterName) => filters.hasOwnProperty(filterName);

    const getSearchQuery = () => '?' + searchParams.toString();

    return {
        parseFiltersFromURLParams,
        setFilterValue,
        buildURL,
        getSearchQuery,
    };
}
